<!--     
    Copyright (c) 2021 nVipani Technology Solutions Private Limited.
    All rights reserved.
  -->
  <div (click)='closeViewImages()' class='nvc-close-position'>
        <div  class='fa fa-times nvc-close'></div>
</div>
    
<div fxLayout='row' class="nvc-images-view">
  <div *ngIf="isListDisplay" class='scroll-image' fxLayout='column' fxFlex='20'>
      <div class='gallery' *ngFor='let image of imageGallery; let i=index' (click)="mainImage(i)">
          <img class='img' alt='image' [src]="userService.getImageURL(image[imageURL])">
      </div>
  </div>
  <div fxFlex='5'>
      <mat-icon *ngIf='allImages && allImages.length>0 && currentIndex !== 0' class="fa fa-chevron-left fa-lg nvc-icon-position" (click)='getImages("before")'></mat-icon>
  </div>
  <div fxLayout='column' fxFlex='60' fxLayoutAlign="start center">
      <div class='main-image'>
          <img class='main-img' *ngIf="imageDisplay" [src]="userService.getImageURL(imageDisplay[imageURL], data.default)" alt='image display'>
      </div>
      <div class="nvc-navigators" *ngIf="isListDisplay">
          <img class="nvc-arrow" src="assets/icons/right.svg" alt="left" (click)='moveImage("left")'>
          <img class="nvc-arrow" src="assets/icons/left.svg" alt="right" (click)='moveImage("right")'>
      </div>
  </div>
</div>